import m from "../../geodata/es2015/americanSamoaHigh";
window.am4geodata_americanSamoaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/americanSamoaHigh.js
// module id = null
// module chunks = 